import { render, staticRenderFns } from "./Labels.vue?vue&type=template&id=b2e76188&scoped=true&"
import script from "./Labels.vue?vue&type=script&lang=js&"
export * from "./Labels.vue?vue&type=script&lang=js&"
import style0 from "./Labels.vue?vue&type=style&index=0&id=b2e76188&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e76188",
  null
  
)

export default component.exports